var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-review"},[_c('desktop-user-review',{attrs:{"review":_vm.review}}),_vm._v(" "),_c('mobile-user-review',{attrs:{"review":_vm.review}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }